import qs from 'qs';
import axios from 'axios';
import ResponseInterceptor from '../../../api/response-interceptor';

// Local interception is required, global interception cannot be used, otherwise it will affect the caller
const axiosInstance = axios.create();

axiosInstance.interceptors.response.use(ResponseInterceptor);

/**
 *
 * @param params
 * @return {Promise<ApiProductFreeTrialEntryResponse>}
 */
export const preCheckForFreeTrial = (params = {}) => axiosInstance.get(`/billing/basic/free_trial/condition_check?${qs.stringify(params)}`);

export const preCheckForFreeTrialByCategory = (params = {}) => axiosInstance.get(`/billing/basic/freetrial?${qs.stringify(params)}`);

// export const preCheckForFreeTrial = (params = {}) => {
//   console.log('call free trial api');
//
//   return new Promise((resolve, reject) => {
//     setTimeout(() => {
//       resolve({
//         result: [{
//           'campaignCode': 'zoom_session_campaign',
//           'campaignName': '',
//           'trialCode': 'zoom_session_annual_trial_service',
//           'oldPlanCode': null,
//           'planCode': 'zec_100_unlimited_yearly',
//           'categoryCode': 'ZECSU',
//           'trialCondition': 'qualify',
//           'currentUserHasPermission': true,
//           'billingCycle': 12,
//           'capacity': 100,
//           'remainTrialDays': null
//         }, {
//           'campaignCode': 'zoom_session_campaign',
//           'campaignName': '',
//           'trialCode': 'zoom_session_annual_trial_service',
//           'oldPlanCode': null,
//           'planCode': 'zec_100_unlimited_monthly',
//           'categoryCode': 'ZECSU',
//           'trialCondition': 'trialling',
//           'currentUserHasPermission': true,
//           'billingCycle': 1,
//           'capacity': 100,
//           'remainTrialDays': 14
//         }],
//       });
//     }, 3000);
//   });
// };

export const preCheckForPaid = () => {
  return Promise.resolve({ result: [] });
};
